// The Intl.NumberFormat object enables language-sensitive number formatting.
const _USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

/**
 * Format a number as a currency, specifically USD
 *
 * @param value A number to format as a currency
 * @returns {string} A string formatted as a currency
 */
export const formatCurrency = (value: number) => {
  // Handle nil/invalid values by returning $0.00
  if (value == null || isNaN(value)) {
    return _USDollar.format(0)
  }

  return _USDollar.format(value)
}
